import { AdditionalDocumentType } from '../enums/additionalDocumentTypeEnum'

export const additionalDocumentTypeValues = [
  {
    value: AdditionalDocumentType.IdentityCard,
    label: {
      eng: 'Oud. personalities',
      rus: 'Уд. личности',
      kz: 'Оуд. тұлғалар',
    },
  },
  {
    value: AdditionalDocumentType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Загранпаспорт',
      kz: 'халықаралық төлқұжат',
    },
  },
  {
    value: AdditionalDocumentType.INN,
    label: {
      eng: 'INN',
      rus: 'ИНН',
      kz: 'ҚАЛАЙЫ',
    },
  },
  {
    value: AdditionalDocumentType.MilitaryId,
    label: {
      eng: 'Military ID',
      rus: 'Военный билет',
      kz: 'Әскери билет',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.IdCard,
    label: {
      eng: 'ID-card',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.TempResidencePermit,
    label: {
      eng: 'Temp. residence permit',
      rus: 'РВП',
      kz: 'Уақытша тұруға рұқсат ',
    },
  },
  {
    value: AdditionalDocumentType.ForeignResidencePermit,
    label: {
      eng: 'Residence permit of another country',
      rus: 'ВНЖ другой страны',
      kz: 'Басқа елдің тұруға рұқсаты',
    },
  },
]

export const additionalDocumentTypeValuesKz = [
  {
    value: AdditionalDocumentType.Passport,
    label: {
      eng: 'Biometric passport',
      rus: 'Биометрический паспорт',
      kz: 'Биометриялық төлқұжат',
    },
  },
  {
    value: AdditionalDocumentType.ForeignResidencePermit,
    label: {
      eng: 'Residence permit of another country',
      rus: 'ВНЖ другой страны',
      kz: 'Басқа елдің тұруға рұқсаты',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
]

export const additionalDocumentTypeValuesKzForRf = [
  {
    value: AdditionalDocumentType.IdentityCard,
    label: {
      eng: 'Oud. personalities',
      rus: 'Уд. личности',
      kz: 'Оуд. тұлғалар',
    },
  },
  {
    value: AdditionalDocumentType.TempResidencePermit,
    label: {
      eng: 'Temp. residence permit',
      rus: 'РВП',
      kz: 'Уақытша тұруға рұқсат ',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
]

export const additionalDocumentTypeValuesRfForKz = [
  {
    value: AdditionalDocumentType.Passport,
    label: {
      eng: 'Russian passport',
      rus: 'Внутренний паспорт РФ',
      kz: 'Ресей паспорты',
    },
  },
  {
    value: AdditionalDocumentType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Загранпаспорт',
      kz: 'халықаралық төлқұжат',
    },
  },
  {
    value: AdditionalDocumentType.ForeignResidencePermit,
    label: {
      eng: 'Residence permit of another country',
      rus: 'ВНЖ другой страны',
      kz: 'Басқа елдің тұруға рұқсаты',
    },
  },
  {
    value: AdditionalDocumentType.TempResidencePermit,
    label: {
      eng: 'Temp. residence permit',
      rus: 'РВП',
      kz: 'Уақытша тұруға рұқсат ',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
  {
    value: AdditionalDocumentType.MilitaryRegistrationCertificate,
    label: {
      eng: 'Military registration certificate',
      rus: 'Приписное',
      kz: 'Тіркеу куәлігі',
    },
  },
]

export const additionalDocumentTypeValuesRf = [
  {
    value: AdditionalDocumentType.InternationalPassport,
    label: {
      eng: 'International passport',
      rus: 'Загранпаспорт',
      kz: 'халықаралық төлқұжат',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.MilitaryId,
    label: {
      eng: 'Military ID',
      rus: 'Военный билет',
      kz: 'Әскери билет',
    },
  },
  {
    value: AdditionalDocumentType.MilitaryRegistrationCertificate,
    label: {
      eng: 'Military registration certificate',
      rus: 'Приписное',
      kz: 'Тіркеу куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
]

export const additionalDocumentTypeValuesKgz = [
  {
    value: AdditionalDocumentType.Passport,
    label: {
      eng: 'National passport',
      rus: 'Национальный паспорт ',
      kz: 'Ұлттық паспорт',
    },
  },
  {
    value: AdditionalDocumentType.ForeignResidencePermit,
    label: {
      eng: 'Residence permit of another country',
      rus: 'ВНЖ другой страны',
      kz: 'Басқа елдің тұруға рұқсаты',
    },
  },
  {
    value: AdditionalDocumentType.TempResidencePermit,
    label: {
      eng: 'Temp. residence permit',
      rus: 'РВП',
      kz: 'Уақытша тұруға рұқсат ',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
]

export const additionalDocumentTypeValuesOthers = [
  {
    value: AdditionalDocumentType.ForeignResidencePermit,
    label: {
      eng: 'Residence permit of another country',
      rus: 'ВНЖ другой страны',
      kz: 'Басқа елдің тұруға рұқсаты',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
]

export const additionalDocumentTypeValuesGbr = [
  {
    value: AdditionalDocumentType.IdCard,
    label: {
      eng: 'CitizenCard',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
  {
    value: AdditionalDocumentType.ForeignResidencePermit,
    label: {
      eng: 'Residence permit of another country',
      rus: 'ВНЖ другой страны',
      kz: 'Басқа елдің тұруға рұқсаты',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
]

export const additionalDocumentTypeValuesBel = [
  {
    value: AdditionalDocumentType.IdCard,
    label: {
      eng: 'CitizenCard',
      rus: 'ID карта',
      kz: 'Жеке куәлік',
    },
  },
  {
    value: AdditionalDocumentType.DriverLicense,
    label: {
      eng: "Driver's license",
      rus: 'Водительское удостоверение',
      kz: 'Жүргізуші куәлігі',
    },
  },
  {
    value: AdditionalDocumentType.Diploma,
    label: {
      eng: 'Diploma',
      rus: 'Диплом',
      kz: 'Диплом',
    },
  },
  {
    value: AdditionalDocumentType.StudentId,
    label: {
      eng: 'Student ID',
      rus: 'Студенческий билет',
      kz: 'Студенттік ID',
    },
  },
]
